interface iConfig {
  API_URL: string;
  API_KEY: string;
  CLERK_API_URL: string;
  TERRITORIES_API_URL: string;
  VOICEFLOW_PROJECT_ID: string;
  VOICEFLOW_VERSION_ID: string;
}

export const configuration: iConfig = {
  API_URL: import.meta.env.VITE_API_URL || '',
  API_KEY: import.meta.env.VITE_API_KEY || '',
  CLERK_API_URL: import.meta.env.VITE_CLERK_API_URL || '',
  TERRITORIES_API_URL: import.meta.env.VITE_TERRITORIES_API_URL || '',
  VOICEFLOW_PROJECT_ID: import.meta.env.VITE_VOICEFLOW_PROJECT_ID || '',
  VOICEFLOW_VERSION_ID: import.meta.env.VITE_VOICEFLOW_VERSION_ID || '',
};
